// extracted by mini-css-extract-plugin
export default {"container":"IZTPZ8","viewer":"JsALfu","truncated":"eiiV2u","expandTransition":"jOi24k","shrinkTransition":"Ww_2uT","showMore":"W_lo1c"};